import BossModel from "@/models/BossModel";

export default class Province extends BossModel {

    /**
     * @type {string}
     */
    static apiUrl = 'province';

    /**
     * @type {string}
     */
    static entity = 'provinces';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
		}
	}

}
